import FormAside from "./FormAside";
import Form from "./Form";
import './layouts.css'

function FormLayout() {

    return (
        <div className="layout">
            <FormAside className="sideBar"/>
            <Form  className='mainBlock' />

        </div>


    )
}

export default FormLayout;